import type { InfiniteData, QueryClient, Updater } from "@tanstack/react-query";
import type { TransactionDetailsModel } from "@/features/collections/api/models/TransactionDetailsModel";
import { TransactionDetailsSortOrderLabels } from "@/features/collections/TransactionDetailsSortOrder";
import type { PaginatedResponseModel } from "@/lib/http";

type TransactionListData = InfiniteData<PaginatedResponseModel<TransactionDetailsModel>>;

export const patchTransactionAfterMutation = (queryClient: QueryClient, collectionId: string, variantId: string, updater: Updater<TransactionListData | undefined, TransactionListData>) => {
	for (const sortOrder of Object.keys(TransactionDetailsSortOrderLabels)) {
		queryClient.setQueriesData({ queryKey: ["transactions", collectionId, sortOrder] }, updater);
	}

	queryClient.setQueriesData({ queryKey: ["transactions", collectionId, variantId] }, updater);
};
